import { config } from "_config";
import {
  authHeader,
  getApiProxyUrl,
  handleResponse,
  handleResponseLogin,
  mappingQueryParams,
  phoneCleaner,
} from "_helpers";

const { customerApiUrl, usersApiUrl } = config;

export const userService = {
  signin,
  crmSignin,
  resetPassword,
  crmResetPassword,
  login,
  crmLogin,
  logout,
  getMe,
  crmGetMe,
  updateInfo,
  crmUpdateInfo,
};

function signin({ token, password, category }) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ password, category }),
  };

  const url = `${customerApiUrl}/customers/set-password`;

  return fetch(url, requestOptions).then(handleResponseLogin);
}

function crmSignin({ token, password, category }) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ password, category }),
  };

  const url = `${getApiProxyUrl()}/customers/set-password`;

  return fetch(url, requestOptions).then(handleResponseLogin);
}

function resetPassword({ email, category }) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const url = `${customerApiUrl}/customers/reset-password${mappingQueryParams({ email, category })}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmResetPassword({ email, category }) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const url = `${getApiProxyUrl()}/customers/reset-password${mappingQueryParams({ email, category })}`;

  return fetch(url, requestOptions).then(handleResponse);
}

function login(username, password, category) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic ${window.btoa(`%${category}%` + username + ":" + password)}`,
    },
  };

  const url = `${usersApiUrl}/users/oauth2/token`;

  return fetch(url, requestOptions).then(handleResponse);
}

function crmLogin(username, password) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic " + window.btoa(username + ":" + password),
    },
  };

  const url = `${getApiProxyUrl()}/users/oauth2/token`;

  return fetch(url, requestOptions).then(handleResponse);
}

function getMe(user) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${customerApiUrl}/customers/me`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((userdetail) => {
      if (user) {
        const userdata = {
          ...user,
          ...{
            username: userdetail.username,
          },
        };
        localStorage.setItem("trademark-membership-user", JSON.stringify(userdata));
        return userdata;
      }
      return userdetail;
    });
}

function crmGetMe(user) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  const url = `${getApiProxyUrl()}/customers/me`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((userdetail) => {
      if (user) {
        const userdata = {
          ...user,
          ...{
            username: userdetail.username,
          },
        };
        localStorage.setItem("trademark-membership-user", JSON.stringify(userdata));
        return userdata;
      }
      return userdetail;
    });
}

function updateInfo(user) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ ...user, phone: phoneCleaner(user.phone) }),
  };

  const url = `${customerApiUrl}/customers/${user.uid}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((userdetail) => {
      localStorage.setItem("userInfo", JSON.stringify(userdetail));

      return userdetail;
    });
}

function crmUpdateInfo(user) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify({ ...user, phone: phoneCleaner(user.phone) }),
  };

  const url = `${getApiProxyUrl()}/customers/${user.uid}`;

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((userdetail) => {
      localStorage.setItem("userInfo", JSON.stringify(userdetail));

      return userdetail;
    });
}

function logout() {
  localStorage.removeItem("trademark-membership-user");
  localStorage.removeItem("userInfo");
}
